import React from "react";
import MediaQuery from "react-responsive";
import MonthSummaryMain from "./MonthSummaryMain";

export default function MonthSummaryContainer() {
    return (
        <MediaQuery maxWidth="599px">
            {(isMobile) => <MonthSummaryMain isMobile={isMobile} />}
        </MediaQuery>
    );
}
